'use strict';

(function(z, _) {


    /**
     * Material grid
     */
    z.TransferMaterialHistoryGrid = z.GridView.extend({


        /**
         * Bounding element
         */
        el: "#page-wrapper",

        /**
         * Events
         *
         * @return {undefined}
         */
        events: function() {
            return _.extend({}, z.FiltersView.prototype.events,{

            });
        },

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function() {
            z.GridView.prototype.initialize.apply(this, arguments);

            this.initializeEvents();
        },

        /**
         * Initialize the events.
         *
         * @return {undefined}
         */
        initializeEvents: function() {

            this.$(".chosen-select").chosen({
                search_contains: true
            });

            this.datepickerLoader(this.$('#transition_created_date_start_field'));
            this.datepickerLoader(this.$('#transition_created_date_end_field'));
        },


        /**
         * Load the datepicker when the field is clicked
         *
         * @param {string} $input -jquery element for the daterangepicker field
         *
         * @return {undefined}
         */
        datepickerLoader: function ($input) {

            var DATE_FORMAT = 'DD-MM-YYYY';
            this.$($input).daterangepicker({
                autoUpdateInput: false,
                showDropdowns: true,
                singleDatePicker: true,
                timePicker: false,
                timePicker24Hour: false,
                timePickerSeconds: false,
                autoApply: true,
                locale: {
                    format: DATE_FORMAT
                }
            });

            // this is official solution for initial empty field
            this.$($input).on('apply.daterangepicker', function (event, picker) {
                $(this).val(picker.startDate.format(DATE_FORMAT));
            });
        },

        /**
         * Get datatable id.
         *
         * @return {string} - datatable id
         */
        getDatatableId: function() {
            return 'material_transfers_history-datatable';
        },

        /**
         * Get page path.
         *
         * @return {string} - page path
         */
        getPath: function() {
            return 'transfershistory';
        },

    });

})(window.z = window.z || {}, _);
